import { IonContent } from '@ionic/react';
import MenuItemsModal from '../../../../modals/MenuItem/MenuItemsModal';
import { MenuItemModalProps } from '../../../../services/exports/Interfaces';
import ModalWrapper from '../../components/modals/ModalWrapper';
import { FC } from 'react';
import { IModal } from '../../router/ModalRouter';

const MenuItemModal: FC<Partial<IModal & MenuItemModalProps>> = (props): JSX.Element => {
  return (
    <ModalWrapper>
      <IonContent className="min-h-[90dvh]">
        <MenuItemsModal {...props} />
      </IonContent>
    </ModalWrapper>
  );
};

export default MenuItemModal;
